import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {

	return {
		content: {
			padding   : "0 1.5rem",
			marginTop : "10rem"
		},
		label: {
			color        : theme.other.colors.text.primary,
			marginBottom : "0.75rem",
			fontSize     : "1.6rem"
		},
		disableBtn: {
			opacity: "0.5"
		},
		submitBtnText: {
			color         : theme.other.paletteNew.secondaryWhite,
			textTransform : "none",
			fontSize      : "1rem"
		},
		inputContainer: {
			"& input": {
				textAlign: "center"
			}
		},
		helpLink: {
			color    : theme.other.paletteNew.primaryDarkBlue,
			cursor   : "pointer",
			width    : "fit-content",
			margin   : "auto",
			fontSize : "1.4rem",

			"&:hover": {
				textDecoration: "underline"
			}
		},
		errorMsg: {
			color: theme.other.paletteNew.tertiaryErrorRed
		},
		submitBtn: {
			marginBottom: "2.5rem"
		},
		activationContainer: {
			// display        : "flex",
			justifyContent : "center",
			alignItems     : "center"
		},
		tickIcon: {
			marginBottom: "1.5rem"
		},
		successText: {
			color      : theme.other.colors.text.primary,
			fontSize   : "1.75rem",
			fontWeight : "500"
		},
		portal: {
			left: "-10% !important"
		}
	};
} );

